import { ReactNode } from 'react';
import { Card, CardContent, CardHeader } from '@etherisc/ui-kit';

interface FormCardProps {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
}

export function FormCard({ title, description, children, className = '' }: FormCardProps) {
  return (
    <Card className={`shadow-lg ${className}`}>
      <CardHeader>
        <div>
          <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
          {description && (
            <p className="text-gray-600 mt-1">{description}</p>
          )}
        </div>
      </CardHeader>
      <CardContent>
        {children}
      </CardContent>
    </Card>
  );
}

interface FormSectionCardProps {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
}

export function FormSectionCard({ title, description, children, className = '' }: FormSectionCardProps) {
  return (
    <Card className={`shadow-md ${className}`}>
      <CardHeader>
        <div>
          <h3 className="text-lg font-medium text-gray-900">{title}</h3>
          {description && (
            <p className="text-gray-500 text-sm mt-1">{description}</p>
          )}
        </div>
      </CardHeader>
      <CardContent>
        {children}
      </CardContent>
    </Card>
  );
} 